export const listHasValidItens = (list) => {
  return list?.filter(item => (typeof item === 'string') ? item.trim() : item).length > 0 || false;
};